var exports = {
  "az": "Box__yNj5SH",
  "wy": "Box_1__KSP2ys",
  "bH": "ColorDecorator__kAe7L1",
};

module.exports = exports;
